import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from '../AuthContext';
import UnderConstruction from '../components/UnderConstruction';
import Login from '../pages/Login'; // Placeholder for login page
import Home from "../pages/Home";
import AboutUs from "../pages/AboutUs";
import Ministries from "../pages/Ministries";
import Blog from "../pages/Blog";
import BlogEditor from "../pages/BlogEditor";
import BlogPost from "../pages/BlogPost";
import OnlineSermons from "../pages/OnlineSermons";
import SermonDetail from "../pages/SermonDetail";
import SermonEditor from "../pages/SermonEditor";
import Resources from "../pages/Resources";
import StatementOfFaith from "../pages/StatementOfFaith";
import Constitution from "../pages/Constitution";
import ContactUs from "../pages/ContactUs";
import AdminDashboard from "../pages/AdminDashboard";
import Layout from "../components/Layout";
import { HelmetProvider } from 'react-helmet-async';

const AppRoutes = () => (
  // <Router>
  //   <AuthProvider>
  //     <Routes>
  //       <Route path="/login" element={<Login />} />
  //       <Route path="/admin-dashboard" element={<AdminDashboard />} />
  //       <Route
  //         element={
  //           <UnderConstruction>
  //             <Layout />
  //           </UnderConstruction>
  //         }
  //       >
  //         <Route path="/" element={<Home />} />
  //         <Route path="/about-us" element={<AboutUs />} />
  //         <Route path="/ministries" element={<Ministries />} />
  //         <Route path="/blog" element={<Blog />} />
  //         <Route path="/blog/:id" element={<BlogPost />} />
  //         <Route path="/online-sermons" element={<OnlineSermons />} />
  //         <Route path="/resources" element={<Resources />} />
  //         <Route path="/contact-us" element={<ContactUs />} />
  //       </Route>
  //     </Routes>
  //   </AuthProvider>
  // </Router>
// OLD CODE (ENABLE THIS AGAIN ONCE TESTING IS COMPLETE):
  <HelmetProvider>
  <Router>
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<Layout />}>
  <Route path="/" element={<Home />} />
  <Route path="/about-us" element={<AboutUs />} />
  <Route path="/about-us/statement-of-faith" element={<StatementOfFaith />} />
  <Route path="/about-us/church-constitution" element={<Constitution />} />
  <Route path="/ministries" element={<Ministries />} />
  <Route path="/blog" element={<Blog />} />
  <Route path="/blog/:id" element={<BlogPost />} />
  <Route path="/online-sermons" element={<OnlineSermons />} />
  <Route path="/online-sermons/:id" element={<SermonDetail />} />
  <Route path="/resources" element={<Resources />} />
  <Route path="/contact-us" element={<ContactUs />} />
  <Route path="/admin-dashboard" element={<AdminDashboard />} />
  <Route path="/admin/blog-editor" element={<BlogEditor />} />
  <Route path="/admin/blog-editor/:id" element={<BlogEditor />} />
  <Route path="/admin/sermon-editor" element={<SermonEditor />} />
</Route>
      </Routes>
    </AuthProvider>
  </Router>
  </HelmetProvider>
);

export default AppRoutes;